import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { AddAdditionalInformationRequest, AdditionalInformationRequest, UpdateAdditionalInformationByMentorRequest } from '../../models/account/additional-information/additionalInformationRequest';
import { apiResponse } from '../../models/apiResponse';
import { AdditionalInformationResponse } from '../../models/account/additional-information/additionalInformationResponse';
import { map, Observable, ObservableLike, Subject } from 'rxjs';
import { GetAdditionalInformationRequest } from '../../models/account/additional-information/getAdditionalInformationRequest';
import { GetAdditionalInformationResponse } from '../../models/account/additional-information/getAdditionalInformationResponse';
import { UpdateAdditionalInformationRequest } from '../../models/account/additional-information/updateAdditionalInformationRequest';
import { GetAdditionalInformationByTypesRequest } from '../../models/account/additional-information/GetAdditionalInformationByTypesRequest';

@Injectable({
  providedIn: 'root'
})
export class AdditionalInformationService {

  private loadDataSubject = new Subject<void>;
  triggerLoadData(){
    this.loadDataSubject.next();
  }
  getLoadDataObserrvable(){
    return this.loadDataSubject.asObservable();
  }

  constructor(private genericService: GenericService) { }

  additonalInfoRequest$= new Subject<AdditionalInformationResponse>();
  additonalInfoResponse$= new Subject<AdditionalInformationResponse>();

  postAdditionalQuestion(additionalInformationRequest: AddAdditionalInformationRequest): Observable<apiResponse<AdditionalInformationResponse>>
  {
    return this.genericService.post('additionalinfo',additionalInformationRequest);
  }

  getAdditionalInformation(getAdditionalInformationRequest: GetAdditionalInformationRequest): Observable<GetAdditionalInformationResponse>
  {
    return this.genericService.post<GetAdditionalInformationResponse>('additionalinfo/status/type', getAdditionalInformationRequest)
  }

  getRecentAdditionalInformation(additionalInformationRequest: AdditionalInformationRequest): Observable<AdditionalInformationResponse>
  {
    return this.genericService.post(`recentadditionalinfo`, additionalInformationRequest)
  }

  updateAdditionalInformationByMentor(req: UpdateAdditionalInformationByMentorRequest): Observable<AdditionalInformationResponse>
  {
   return this.genericService.put(`mentor/additionalinfo`, req)
  }

  updateAdditionalInformation(updateAdditionalInformationRequest: UpdateAdditionalInformationRequest): Observable<AdditionalInformationResponse>
  {
    const documentData = new FormData();
    documentData.append('id',updateAdditionalInformationRequest.id.toString());
    documentData.append('reply',updateAdditionalInformationRequest.reply);
    if(updateAdditionalInformationRequest.attachment){
      documentData.append('attachment', updateAdditionalInformationRequest.attachment, updateAdditionalInformationRequest.attachment.name);  // Add file with its original name
    }
    return this.genericService.put(`additionalinfo`, documentData);
  }

  getAllAdditionalInformationByTypes(getAdditionalInformationByTypesRequest: GetAdditionalInformationByTypesRequest): Observable<GetAdditionalInformationResponse>
  {
    return this.genericService.post<GetAdditionalInformationResponse>(`additionalinfo/bytypes`, getAdditionalInformationByTypesRequest);
  }
}
